/**
 * Calculate the reading delay for a message based on its content length
 * Uses average reading speed and adds buffer time
 * 
 * @param {string} messageContent - The content of the message
 * @returns {number} Delay in milliseconds before showing resolution popup
 */
const calculateReadingDelay = (messageContent) => {
  if (!messageContent) return 3000; 
  
  // Average reading speed: 100 words per minute (slightly slower for comprehension)
  const avgReadingSpeed = 100;
  
  // Average word length in characters (including space)
  const avgWordLength = 5;
  
  // Calculate characters per second
  const charactersPerSecond = (avgReadingSpeed * avgWordLength) / 60;
  
  const contentLength = messageContent.length;
  const readingTimeSeconds = contentLength / charactersPerSecond;
  
  const totalTimeSeconds = readingTimeSeconds;
  
  const delayMs = Math.max(3000, Math.min(10000, totalTimeSeconds * 1000));
  
  return delayMs;
};

export default calculateReadingDelay;

